import {
  TMergeCartsLoadingAction,
  EMergeCartsTypes,
  IMergeCartsParam,
  IMergeCartsAPIResponse,
} from '../../types/mergeCarts.types';
import { GET_MERGE_CARTS_API } from '../../constants/apis.constant';
import { EApiMiddlewareMethods } from 'config/redux/middlewares/api.middleware.types';

// import LoadingEllipsis from 'common/LoadingEllipsis';
// import { showPageLoader, hidePageLoader } from 'common/PageLoader/redux/pageLoader.action';
import { showNotification } from 'common/Notification/redux/notification.action';
import { updateCart as oldUpdateCart } from 'pages/Cart/redux/actions/getCart.action';
import APP_CONFIG from 'config/App.config';
import {
  NEW_GET_MERGE_CARTS_API,
  NEW_GET_MERGE_CARTS_API_V3,
} from 'pages/Cart/constants/new.apis.constant';
import { transfromGetCart } from './newCart.actions';
import { createGrowthBookInstance } from '@mafc/appshell';
import { isUserShareMember } from '@mafc/common';
import { IAppState } from 'config/redux/reducers';
import { Dispatch } from 'redux';
import { updateCart } from 'pages/NewCart/redux/actions/fetchCart.actions';
import { cartReponseShaper } from 'pages/NewCart/redux/actions/cartAction.helper';
import { notificationTypes } from 'common/Notification/redux/notification.type';

export const setMergeCartsLoading = (loading: boolean): TMergeCartsLoadingAction => ({
  type: EMergeCartsTypes.MERGE_CARTS_SET_LOADING,
  payload: { loading },
});

export const mergeCarts = ({ areacode, toMergeCartGuid, successCallback, t }: IMergeCartsParam) => (
  dispatch: Dispatch,
  getState: () => IAppState
) => {
  let url = APP_CONFIG.isNewEndpoint ? NEW_GET_MERGE_CARTS_API : GET_MERGE_CARTS_API;
  const store = getState();
  const growthbook = createGrowthBookInstance(
    {
      ...store.appConfig.growthBook,
    },
    store
  );
  const { value } = growthbook.feature('new_carrefour_journey');
  const { new_journey = false } = value || { new_journey: false };
  if (new_journey) {
    url = NEW_GET_MERGE_CARTS_API_V3;
  }
  const isShareMember = isUserShareMember(store);
  // This shouldn't be here! May need to change later
  dispatch(setMergeCartsLoading(true));
  dispatch({
    type: EMergeCartsTypes.MERGE_CARTS_GET_REQ,
    payload: {
      url,
      apiVersion: new_journey ? 3 : 2,
      method: EApiMiddlewareMethods.POST,
      enableProgress: false,
      params: {
        areacode,
        toMergeCartGuid,
        lm: isShareMember,
      },
      onSuccess: (data: IMergeCartsAPIResponse) => {
        const {
          cartData = {},
          showMergeMessage = false,
          cartModified = false,
          cartResponse = {},
        } = data;
        const response = Object.keys(cartData).length > 0 ? cartData : cartResponse;
        const message = [];
        if (showMergeMessage) {
          message.push(t('mergeCart'));
        }
        if ((cartData && cartData.cartModified) || cartModified) {
          message.push(t('quantityRestriction.cartMergeRestriction'));
        }
        if (message.length > 0) {
          dispatch(
            showNotification({
              type: notificationTypes.success,
              message,
            }) as any
          );
        }

        if (successCallback) {
          successCallback(showMergeMessage);
        }

        // Update cart state
        oldUpdateCart(dispatch as any, transfromGetCart(response));
        if (new_journey) {
          updateCart(dispatch, cartReponseShaper(response));
        }
      },

      // According to Pratik no need to throw an error since erros will be normal for the process
      // hence handling it silently
      onFailure: () => {
        if (successCallback) {
          successCallback(false);
        }
      },
      onFinally: () => dispatch(setMergeCartsLoading(false)),
    },
  });
};
